
import React from 'react'
import './subLoadingComponent.css'

function SubLoadingComponent() {
    return (
        <div className="sub-lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default SubLoadingComponent